
export const environment = {
  production: true,
  URL_API: 'https://tstapi.polivias.app/api',//homologação
  LINK_WHATSAPP: 'https://polivias.page.link/app-invite'
};

